// src/context/ProjectContext.jsx
import { createContext, useContext, useState } from "react";

const ProjectContext = createContext();

export const ProjectProvider = ({ children }) => {
  const [projectInfo, setProjectInfo] = useState({
    groupId: null,
    projectId: null,
    fileId: null,
    modelType: null,
  });

  const [userInfo, setUserInfo] = useState(null); // ✅ 사용자 정보 상태 추가
  console.log("Context", userInfo);
  return (
    <ProjectContext.Provider
      value={{
        projectInfo,
        setProjectInfo,
        userInfo,
        setUserInfo, // ✅ 헤더 등에서 업데이트 가능
      }}
    >
      {children}
    </ProjectContext.Provider>
  );
};

export const useProject = () => useContext(ProjectContext);
